import { Moment } from 'moment'

import { AppDispatch } from '../../../store'
import { IDeletedAppointment } from '../Client/IDeletedAppointment'

import Client from './../Client/Client'
import {
  GET_DELETED_APPOINTMENTS_LOADING,
  GET_DELETED_APPOINTMENTS_SUCCESS,
  GET_DELETED_APPOINTMENTS_FAILURE,
} from './actionTypes'

export const getDeletedAppointments = (startDate: Moment, endDate: Moment) => {
  return (dispatch: AppDispatch) => {
    dispatch({
      type: GET_DELETED_APPOINTMENTS_LOADING,
    })

    return Client.getDeletedAppointments(startDate, endDate).then(
      (deletedAppointments: any[]) => {
        dispatch(getDeletedAppointmentsSuccess(deletedAppointments))
      },
      message => {
        dispatch(getDeletedAppointmentsFailure(message))
      },
    )
  }
}

const getDeletedAppointmentsSuccess = (
  deletedAppointments: IDeletedAppointment[],
) => {
  return {
    type: GET_DELETED_APPOINTMENTS_SUCCESS,
    payload: {deletedAppointments: deletedAppointments},

  }
}
const getDeletedAppointmentsFailure = (message: string) => {
  return {
    type: GET_DELETED_APPOINTMENTS_FAILURE,
    message,
  }
}
